import { getRoutes } from "../utilities/routes";

// Types
export interface FollowUpGroup {
  id: number;
  title: string;
  priority: number;
  isSendSMS: boolean;
  sampleSMSPayment?: string;
  serviceRef: number;
  createdOn: string;
  modifiedOn: string;
}

export interface ApiResponse<T> {
  status: boolean;
  data: T;
  message?: string;
}

// API functions
export const fetchFollowUpGroups = async (
  token: string
): Promise<FollowUpGroup[]> => {
  const routes = getRoutes();
  const response = await fetch(
    routes.FollowupRoutes || "/api/followup-groups",
    {
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
    }
  );

  if (!response.ok) {
    const errorData = await response.json().catch(() => null);
    const errorMessage =
      errorData?.message ||
      errorData?.title ||
      `Failed to fetch follow-up groups: ${response.statusText}`;
    throw new Error(errorMessage);
  }

  return response.json();
};

export const fetchFollowUpGroupById = async (
  id: number,
  token: string
): Promise<FollowUpGroup> => {
  const routes = getRoutes();
  const response = await fetch(
    `${routes.FollowupRoutes || "/api/followup-groups"}/${id}`,
    {
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
    }
  );

  if (!response.ok) {
    const errorData = await response.json().catch(() => null);
    const errorMessage =
      errorData?.message ||
      errorData?.title ||
      `Failed to fetch follow-up group: ${response.statusText}`;
    throw new Error(errorMessage);
  }

  return response.json();
};
